import api from '.';

export const _saveEmpresa = async (json, headers) => {
    return await api.post('empresas', json, headers).then(response => { return response });
}

export const _getStatusPagamento = async (json, headers) => {
    //return await api.post('empresas/statusPagamento', json, headers).then(response => { return response });
    return await api.post('empresas/statusPagamento', json, headers).then(response => { return response });
}

export const _getHistoricoPagamentos = async (json, headers) => {
    //return await api.post('empresas/statusPagamento', json, headers).then(response => { return response });
    return await api.post('empresas/historicoPagamentos', json, headers).then(response => { return response });
}

//nova fatura banco inter
export const _gerarFatura = async (json, headers) => {
    return await api.post('empresas/gerarFatura', json, headers).then(response => { return response });
}

//descontinuada (versão mercado pago)
export const _geraPagamento = async (values, headers) => {
    return await api.post('empresas/geraPagamento', values, headers).then(response => { return response });
}